import { CarryoverApprovalStatus } from '../../../../enums/carryover-approval-status.enum';
import { SelectItem } from 'primeng';

export class CarryoverUtils {
  public static getStatusClass(status: CarryoverApprovalStatus): string {
    switch (status) {
      case CarryoverApprovalStatus.AutoApproved:
        return 'status-auto-approved';
      case CarryoverApprovalStatus.AutoRejected:
        return 'status-auto-rejected';
      case CarryoverApprovalStatus.ManuallyApproved:
        return 'status-manually-approved';
      case CarryoverApprovalStatus.ManuallyRejected:
        return 'status-manually-rejected';
      case CarryoverApprovalStatus.Requested:
        return 'status-requested';
      case CarryoverApprovalStatus.NotRequested:
      default:
        return 'status-not-requested';
    }
  }

  public static carryoverStatusOptions: SelectItem[] = [
    {
      label: 'Manually Approved',
      value: CarryoverApprovalStatus.ManuallyApproved,
    },
    {
      label: 'Manually Rejected',
      value: CarryoverApprovalStatus.ManuallyRejected,
    },
    { label: 'Requested', value: CarryoverApprovalStatus.Requested },
    { label: 'Not Requested', value: CarryoverApprovalStatus.NotRequested },
    { label: 'Auto Approved', value: CarryoverApprovalStatus.AutoApproved, disabled: true },
    { label: 'Auto Rejected', value: CarryoverApprovalStatus.AutoRejected, disabled: true },
    { label: 'Unset', value: CarryoverApprovalStatus.Unset, disabled: true },
  ];
  public static getStatusLabel(status: CarryoverApprovalStatus): string {
    return CarryoverUtils.carryoverStatusOptions.find((x) => x.value === status)?.label ?? 'Unset';
  }
}
